import { useCallback } from 'react';
import { Tooltip, IconButton, Divider } from '@mui/material';
import { Visibility, OpenInNew } from '@mui/icons-material';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

export default function useOpenRowDataGrid() {
  const { t } = useTranslation('translation');

  return useCallback(
    (getLink, customActions = null) => ({
      field: '__view__',
      width: customActions ? 150 : 105,
      headerName: t('donations.view'),
      sortable: false,
      disableClickEventBubbling: true,
      filterable: false,
      renderCell: (params) => {
        const link = getLink(params);
        const hasLink = Boolean(link);
        const isDeleted = Boolean(params.row?.is_deleted);

        if (!hasLink && !customActions) {
          return null;
        }

        return (
          <>
            {hasLink ? (
              <>
                <Tooltip
                  title={
                    isDeleted
                      ? t('common.item-might-have-been-removed')
                      : t('donations.view')
                  }
                >
                  {isDeleted ? (
                    <span>
                      <IconButton disabled data-tour="open-donation-eye">
                        <Visibility />
                      </IconButton>
                    </span>
                  ) : (
                    <Link to={link} onClick={(e) => e.stopPropagation()}>
                      <IconButton data-tour="open-donation-eye">
                        <Visibility />
                      </IconButton>
                    </Link>
                  )}
                </Tooltip>

                <Tooltip
                  title={
                    isDeleted
                      ? t('common.item-might-have-been-removed')
                      : t('donations.view-in-tab')
                  }
                >
                  {isDeleted ? (
                    <span>
                      <IconButton disabled>
                        <OpenInNew />
                      </IconButton>
                    </span>
                  ) : (
                    <Link
                      to={link}
                      target="_blank"
                      onClick={(e) => e.stopPropagation()}
                    >
                      <IconButton>
                        <OpenInNew />
                      </IconButton>
                    </Link>
                  )}
                </Tooltip>
              </>
            ) : null}

            {customActions && (
              <Divider orientation="vertical" flexItem sx={{ mx: 1 }} />
            )}

            {customActions && customActions(params)}
          </>
        );
      },
    }),
    [t]
  );
}
